<template>
  <div class="droppable" :class="`zone-${target}`" ref="el">
    <slot />
  </div>
</template>
<script setup>
import interact from 'interactjs'
import { ref, onMounted } from 'vue'
const el = ref(null)

const isGood = ref(false)

const emit = defineEmits(['addPoint'])

const props = defineProps(['target'])

onMounted(() => {
  interact(el.value).dropzone({
    accept: `.puzzle-${props.target}`,
    overlap: 0.2,

    ondropactivate: function (event) {
      //   event.target.classList.add("can--drop");
    },
    ondragenter: function (event) {
      // console.log('in', props.target)
      var draggableElement = event.relatedTarget,
        dropzoneElement = event.target,
        dropRect = interact.getElementRect(dropzoneElement),
        dropCenter = {
          x: dropRect.left + dropRect.width / 2,
          y: dropRect.top + dropRect.height / 2
        }

      let classDrag = Array.from(draggableElement.classList).filter((o) => {
        return o.includes(`puzzle-${props.target}`)
      })
      if (classDrag.length > 0) {
        dropzoneElement.classList.add('highlight')
      }
      // console.log('ENTER', dropCenter)
      event.draggable.draggable({
        snap: {
          targets: [dropCenter]
        }
      })
    },
    ondragleave: function (event) {
      // console.log('out', props.target)
      let elem = event.draggable.target,
        dropzoneElement = event.dropzone.target,
        startx = elem.dataset.startx,
        starty = elem.dataset.starty,
        startCenter = {
          x: parseFloat(startx),
          y: parseFloat(starty)
        }

      dropzoneElement.classList.remove('highlight')
      // event.draggable.draggable(false)
      // console.log('LEAVE', startCenter)
      // event.draggable.snap(false)
      event.draggable.draggable({
        snap: {
          targets: [startCenter]
        }
      })
    },
    ondrop: function (event) {
      let dropzoneElement = event.dropzone.target

      dropzoneElement.classList.remove('highlight')
      dropzoneElement.classList.add('success')
      // console.log('drop', props.target)
      if (!isGood.value) {
        isGood.value = true
        let el = event.draggable.target
        el.classList.add('dropped')
        // dropzoneElement.classList.remove('highlight')
        // console.log('isGood', isGood.value)
        emit('addPoint')
      }
      //   event.interaction.doMove();
    }
  })
})
</script>
<style></style>
